import { useEffect } from 'react'
import { useInView } from 'react-intersection-observer'
import { useInfiniteQuery } from '@tanstack/react-query'

export const useInfiniteScroll = (queryKey, queryFn) => {
    const { ref, inView } = useInView({
        threshold: 0.1,
        rootMargin: '10px',
        delay: 100
    })

    const {
        data,
        fetchNextPage,
        hasNextPage,
        isFetchingNextPage,
        isLoading,
        isError,
        error,
        refetch
    } = useInfiniteQuery({
        queryKey: [queryKey],
        queryFn: ({ pageParam }) => queryFn({ pageParam }),
        getNextPageParam: (lastPage) =>
            lastPage.hasMore ? lastPage.lastVisible : undefined,
        initialPageParam: null,
        refetchOnMount: true
    })

    useEffect(() => {
        const loadMore = async () => {
            if (inView && hasNextPage && !isFetchingNextPage) {
                await fetchNextPage()
            }
        }
        loadMore()
    }, [inView, hasNextPage, isFetchingNextPage, fetchNextPage])

    const items = data?.pages?.flatMap(page => page.items) ?? []

    return {
        items,
        ref,
        isLoading,
        isError,
        error,
        isFetchingNextPage,
        refetch,
        hasNextPage
    }
}